<template>
  <div class="shopReviewScore">
    <div class="shopReviewScore__item">
      <div class="shopReviewScore__title">満足度平均</div>
      <div class="shopReviewGraph">
        <donut-chart :rating="totalAverageRating"></donut-chart>
        <slider-chart :rating-counts="ratingCounts"></slider-chart>
      </div>
    </div>
    <div class="shopReviewScore__item">
      <div class="shopReviewScore__title">各項目の評価</div>
      <div class="shopReviewRating">
        <div class="shopReviewRating__item" v-for="(label, rating) in ratingLabels" :key="rating">
          <div class="shopReviewRating__label">{{ label }}</div>
          <div class="shopReviewRating__rating">{{ ratingAverages[rating] ? ratingAverages[rating].toFixed(1) : '-' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DonutChart from './donutChart.vue';
import SliderChart from './sliderChart.vue';
export default {
    components: {
        'donut-chart': DonutChart,
        'slider-chart': SliderChart,
    },
    props: {
        shopReviews: {
            type: Array,
            required: true,
        },
    },
    computed: {
        ratingLabels() {
            return {
                access_rating: 'アクセス',
                service_rating: 'サービス',
                room_rating: '会場',
                food_drink_rating: '料理・ドリンク',
                facility_rating: '設備',
                cost_performance_rating: 'コスパ'
            };
        },
        totalAverageRating() {
            if (this.shopReviews.length === 0) {
                return 0;
            }
            const sum = this.shopReviews.reduce((total, review) => {
                return total + this.calculateAverageRating(review);
            }, 0);
            const average = sum / this.shopReviews.length;
            return Math.round(average * 10) / 10;
        },
        ratingCounts() {
            const ratings = ['access_rating', 'room_rating', 'facility_rating', 'service_rating', 'food_drink_rating', 'cost_performance_rating'];
            const counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };

            this.shopReviews.forEach(review => {
                ratings.forEach(rating => {
                    const value = review[rating];
                    if (value >= 1 && value <= 5) {
                        counts[value]++;
                    }
                });
            });
            return counts;
        },
        ratingAverages() {
            if (this.shopReviews.length === 0) {
                return {};
            }
            const ratings = Object.keys(this.ratingLabels);
            const averages = {};

            ratings.forEach(rating => {
                const total = this.shopReviews.reduce((sum, review) => sum + (review[rating] || 0), 0);
                const average = total / this.shopReviews.length;
                averages[rating] = Math.round(average * 10) / 10;
            });
            return averages;
        }
    },
    methods: {
        calculateAverageRating(shopReview) {
            const total =
              shopReview.access_rating +
              shopReview.room_rating +
              shopReview.facility_rating +
              shopReview.service_rating +
              shopReview.food_drink_rating +
              shopReview.cost_performance_rating;
            return total / 6;
        }
    }
};
</script>
